module.exports = __webpack_public_path__ + "img/20211014.7a408c20.png";